"use client"

import type React from "react"

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import NoteAddOutlined from "@mui/icons-material/NoteAddOutlined";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";

import type { ContextMenuState, NewItemDialogState, TreeNode } from "../../file-tree-manager/types/tree-types"
import { useSelector } from "react-redux";

interface ContextMenuProps {
  contextMenu: ContextMenuState | null
  selectedNode: TreeNode | null
  onClose: () => void
  onNewItem: (dialog: NewItemDialogState) => void
  onStartEdit: (id: string, name: string) => void
  onDelete: (id: string) => void
}

export const ContextMenu: React.FC<ContextMenuProps> = ({
  contextMenu,
  selectedNode,
  onClose,
  onNewItem,
  onStartEdit,
  onDelete,
}) => {
  const userInfo = useSelector((state: any) => state.user);

  return (
    <Menu
      open={contextMenu !== null}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
    >
      {contextMenu &&
        selectedNode?.type === "folder" && [
          <MenuItem
            key="new-file"
            onClick={() => {
              onNewItem({ open: true, parentId: selectedNode.id, type: "file" })
              onClose()
            }}
          >
            <NoteAddOutlined sx={{ mr: 1 }} />새 컨텐츠
          </MenuItem>,
        ]}

        <MenuItem
          onClick={() => {
            if (selectedNode) {
              onStartEdit(selectedNode.id, selectedNode.title)
              onClose()
            }
          }}
        >
          <Edit sx={{ mr: 1 }} />
          이름 변경
        </MenuItem>

        {(userInfo.role === "admin" || selectedNode?.type === "file") && [
        <MenuItem
          onClick={() => {
            if (contextMenu) {
              onDelete(contextMenu.nodeId)
              onClose()
            }
          }}
          sx={{ color: "error.main" }}
        >
          <Delete sx={{ mr: 1 }} />
          삭제
        </MenuItem>
        ]}
    </Menu>
  )
}


